export default __webpack_public_path__ + "static/media/storeApp02.cf5bb87e.png";